import { usePunditUserContext } from "@/react/contexts";

export const useIsSitesEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();
  return Boolean(currentCommunitySettings?.sites_enabled);
};
